import ScheduleManagerPage from './container'

export default ScheduleManagerPage